<div class="d-flex">
  <div class="store-images" (click)="file.click()">
    <div class="logo-container" [style.max-width.px]="maxWidth" [style.max-height.px]="maxHeight">
      <div class="opacity-layer"></div>
      <img [style.max-width.px]="maxWidth" [style.max-height.px]="maxHeight" *ngIf="previewUrl" [src]="previewUrl"/>
      <img [style.max-width.px]="maxWidth" [style.max-height.px]="maxHeight" *ngIf="image && !previewUrl"
           [src]="image"/>
      <div class="template" *ngIf="noImage()" [style.width.px]="maxWidth"
           [style.height.px]="maxHeight"></div>
      <i class="fas fa-cloud-upload-alt store-images-upload-icon"
         [style.display]="noImage() ? 'block' : ''"
         [style.color]="noImage() ? '$blue' : '#ffffff'"></i>
      <span class="store-images-upload-icon" [style.display]="noImage() ? 'block' : ''"
            [style.color]="noImage() ? '$blue' : '#ffffff'">{{ uploadText }}</span>
      <i class="fas fa-times-circle removeIcon" (click)="removePicture($event)" *ngIf="!!previewUrl || !!image"></i>
    </div>
  </div>
  <input #file class="d-none" type="file" name="image" accept="image/*" (change)="onFileSelect($event)"/>
</div>
